export const withPreviousDate = trips =>
  (trips &&
    trips.map((trip, i) => ({
      ...trip,
      // TODO change to isNewDay
      isSameDate:
        trips[i - 1] && trips[i - 1].date_formatted == trip.date_formatted
      // prevTrip: trips[i-1]||null
    }))) ||
  []

const initialState = {
  hasSelectedAll: false,
  totalResultsCount: 0,
  wasChecked: localStorage.getItem("wasTxnChecked") || false,
  isPopoverVisible: null,
  isRangePickerOpen: false,

  filterValues: {
    range: [],
    purpose: null,
    transaction_type: null,
    count: null,
    institution_account_token_id: null
  },
  filter_params: {
    token_ids: []
  },
  update_params: {
    purpose: null,
    income_source: null
  },
  tags: [],
  endOfList: false,
  filters: {
    // uncategorized: true
  },
  starting_after: "86507f85375b496f94af1b95fb417fcb", // last trip id
  purpose: [
    "Work",
    "Personal",
    "Charity",
    "Medical"
    // ...
    // customOther
    // if
  ],
  isFetching: false,
  isFetchingTotals: false,
  totals: {
    total_miles: "0",
    total_uncategorized_miles: "0",
    total_trips_deductions: "0"
  },
  checkboxesVisible: false,
  unclassified: 0,
  isFetchingFromBank: false
}

export function filtersReducer(state = initialState.filters, action) {
  switch (action.type) {
    case "APPLY_DATE_FILTER":
      return {
        ...state,
        ...toRangeParams(action.dateRange)
      }

    case "SELECT_FILTER_TRANSACTION_TYPE":
      return {
        ...state,
        transaction_type: action.filter
      }

    case "SELECT_FILTER_CATEGORY":
      return {
        ...state,
        category: action.filter
      }

    case "SELECT_FILTER_INS_ACCOUNT_ID":
      return {
        ...state,
        institution_account_token_id: action.filter
      }

    case "SELECT_FILTER_PURPOSE":
      if (action.filter == "Unclassified")
        return {
          ...state,
          uncategorized: true,
          purpose: null,
          income_source: null
        }

      if (action.income_sources.includes(action.filter))
        return {
          ...state,
          purpose: "Work",
          income_source: action.filter,
          uncategorized: null
        }

      if (action.filter)
        return {
          ...state,
          purpose: action.filter,
          income_source: null,
          uncategorized: null
        }

      if (!action.filter)
        return {
          ...state,
          purpose: null,
          income_source: null,
          uncategorized: null
        }

    case "CLEAR_ALL_FILTERS":
      return initialState.filters

    default:
      return state
  }
}

export function filterValuesReducer(state = initialState.filterValues, action) {
  switch (action.type) {
    case "SELECT_FILTER_TRANSACTION_TYPE":
      return {
        ...state,
        transaction_type: action.filter
      }

    case "SELECT_FILTER_INS_ACCOUNT_ID":
      return {
        ...state,
        institution_account_token_id: action.filter
      }

    case "SELECT_FILTER_CATEGORY":
      return {
        ...state,
        category: action.filter
      }

    case "CLEAR_ALL_FILTERS":
      return initialState.filterValues

    case "APPLY_DATE_FILTER":
      return {
        ...state,
        range: action.dateRange
      }

    case "SELECT_FILTER_PURPOSE":
      return {
        ...state,
        purpose: action.filter
      }

    default:
      return state
  }
}

export function batchReducer(
  state = initialState.filter_params.token_ids,
  action
) {
  switch (action.type) {
    case "UNTOGGLE_ALL_TRANSACTIONS":
      return initialState.filter_params.token_ids

    case "TOGGLE_TRANSACTION":
      return state.includes(action.token_id)
        ? state.filter(token_id => token_id != action.token_id)
        : [...state, action.token_id]

    case "TOGGLE_MANY_TXNS":
      return [...state, ...action.tokenIds]

    default:
      return state
  }
}

export default function transactions(state = initialState, action) {
  switch (action.type) {
    case "IMPORT_TXN_STATUS_REQUEST":
      return {
        ...state,
        isFetching: true,
        isFetchingFromBank: true
      }

    case "SET_UNCLASSIFIED_TXN_COUNT":
      return {
        ...state,
        unclassified: action.count
      }

    case "IMPORT_TXN_STATUS_SUCCESS":
      return {
        ...state,
        isFetching: false,
        isFetchingFromBank: !action.payload.finished
      }

    case "DECREMENT_UNCLASSIFIED_TXN_COUNT":
      return {
        ...state,
        unclassified: state.unclassified - action.count
      }
    case "SHOW_CHECKBOXES":
      return {
        ...state,
        checkboxesVisible: true
      }
    case "HIDE_CHECKBOXES":
      return {
        ...state,
        checkboxesVisible: false
      }

    case "TOGGLE_RANGEPICKER": {
      return {
        ...state,
        isRangePickerOpen: !state.isRangePickerOpen,
        isPopoverVisible: !state.isRangePickerOpen ? true : null
      }
    }

    case "CLOSE_FILTER_POPOVER": {
      return {
        ...state,
        isPopoverVisible: null,
        isRangePickerOpen: false
      }
    }

    case "UPDATE_TRANSACTION_REQUEST":
    case "UPDATE_TRANSACTION_BATCH_REQUEST":
      return {
        ...state,
        isFetching: true
      }
    case "UPDATE_TRANSACTION_ERROR":
    case "UPDATE_TRANSACTION_SUCCESS":
    case "UPDATE_TRANSACTION_BATCH_SUCCESS":
      return {
        ...state,
        isFetching: false
      }

    case "UNTOGGLE_ALL_TRANSACTIONS":
    case "TOGGLE_MANY_TXNS":
    case "TOGGLE_TRANSACTION":
      return {
        ...state,
        wasChecked: true,
        filter_params: {
          token_ids: batchReducer(state.filter_params.token_ids, action)
        }
      }

    case "SELECT_ALL_FILTERED_TXNS":
      return {
        ...state,
        hasSelectedAll: true
      }

    case "UNSELECT_ALL_FILTERED_TXNS":
      return {
        ...state,
        hasSelectedAll: false
      }

    case "SELECT_FILTER_CATEGORY":
    case "SELECT_FILTER_PURPOSE":
    case "SELECT_FILTER_TRANSACTION_TYPE":
    case "SELECT_FILTER_INS_ACCOUNT_ID":
    case "CLEAR_ALL_FILTERS":
    case "APPLY_DATE_FILTER":
      return {
        ...state,
        filters: filtersReducer(state.filters, action),
        filterValues: filterValuesReducer(state.filterValues, action)
      }

    case "NO_MORE_TRANSACTIONS":
      return {
        ...state,
        isFetching: false,
        endOfList: true
      }
    case "GET_TRANSACTION_REQUEST":
      return {
        ...state,
        isFetching: true
      }
    case "GET_TRANSACTION_SUCCESS":
      return {
        ...state,
        isFetching: false
      }
    case "GET_TRANSACTIONS_REQUEST":
      return {
        ...state,
        isFetching: true,
        endOfList: false
      }

    case "LOGIN_REQUEST":
    case "USER_REQUEST":
      return {
        ...state,
        isFetchingTotals: true
      }

    case "LOGIN_SUCCESS":
    case "USER_SUCCESS":
      const totals_names = [
        "total_revenue",
        "total_expenses",
        "total_trips_deductions",
        "total_standard_method_expenses",
        "total_standard_method_revenue",
        "total_miles",
        "total_uncategorized_miles",
        "total_business_miles",
        "total_personal_miles",
        "total_medical_miles",
        "total_charity_miles",
        "total_moving_miles",
        "total_other_miles",
        "total_kms",
        "total_uncategorized_kms",
        "total_business_kms",
        "total_personal_kms",
        "total_medical_kms",
        "total_charity_kms",
        "total_moving_kms",
        "total_other_kms"
      ]

      var totals = {}
      totals_names.forEach(name => {
        totals[name] = action.user[name]
      })

      return {
        ...state,
        isFetching: false,
        isFetchingTotals: false,
        totals: totals,
        unclassified: action.user.total_uncategorized_transactions_count
      }

    case "GET_TOTALS_REQUEST":
      return {
        ...state,
        totals: {},
        isFetchingTotals: true
      }

    case "GET_TOTALS_SUCCESS":
      return {
        ...state,
        totals: action.user.totals,
        isFetchingTotals: false
      }

    case "REMOVE_TXN":
      return {
        ...state,
        totalResultsCount: state.totalResultsCount - 1
      }

    case "GET_TRANSACTIONS_SUCCESS":
      const firstTxn = action.user.transactions[0]
      return {
        ...state,
        isFetching: false,
        totalResultsCount: firstTxn && firstTxn.total_results_count
      }

    default:
      return state
  }
}

// TODO same as in /work-hours

export const toRangeParams = range => {
  if (range.length < 2)
    return {
      start_day: null,
      start_month: null,
      start_year: null,

      end_day: null,
      end_month: null,
      end_year: null
    }

  const start = range[0]
  const end = range[1]
  return {
    start_day: start.format("D"),
    start_month: start.format("M"),
    start_year: start.format("YYYY"),

    end_day: end.format("D"),
    end_month: end.format("M"),
    end_year: end.format("YYYY")
  }
}

export const getPurposes = state => [
  "Work",
  "Personal",
  "Other",
  ...state.models.user.income_sources
]

export const getTxnById = (state, id) =>
  state.models.transactions.find(txn => txn.token_id == id)

export const getFilterCount = ({ range, ...rest }, count = 0) => {
  if (range && range.length > 1) count += 1
  Object.keys(rest).forEach(key => (rest[key] ? (count += 1) : null))
  return count
}



// WEBPACK FOOTER //
// ./src/transactions/reducer.js